export default function titleCase(string: string) {
  var sentence = string.toLowerCase().split(' ');
  for (var i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
  }
  //   document.write(sentence.join(" "));
  return sentence.join(' ');
}

export function parseFloatWithDecimal(str: string, val: number) {
  str = str.toString();

  if (str.indexOf('.') !== -1 || str.indexOf(',') !== -1)
    str = str.slice(0, str.indexOf('.') + val + 1);

  if (str.indexOf('0') === 0) str = str.substring(1);

  return Number(str);
}

export function formatDate(dateString: string, format: string): string {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are zero-based
  const year = date.getFullYear();

  // Replace format placeholders with corresponding date values
  const formattedDate = format
    .replace('DD', String(day).padStart(2, '0'))
    .replace('MM', String(month).padStart(2, '0'))
    .replace('YYYY', String(year));

  return formattedDate;
}
